

  document.addEventListener('DOMContentLoaded', function () {
    const genderNavButtons = document.querySelectorAll('[data-gender-nav]');
    const womenMenuMobile = document.querySelector('.drawer__menu_mobile.women-menu');
    const menMenuMobile = document.querySelector('.drawer__menu_mobile.men-menu');
    const womenMenuTablet = document.querySelector('.header__menu.desktop_menu_women');
    const menMenuTablet = document.querySelector('.header__menu.desktop_menu_men');
    const womenMenuDesktop = document.querySelector('.header__menu.desktop_menu_women');
    const menMenuDesktop = document.querySelector('.header__menu.desktop_menu_men');
    const womenTabEls = document.querySelectorAll('[data-gender-nav="women"]');
    const menTabEls = document.querySelectorAll('[data-gender-nav="men"]');
    const womenImage = document.querySelector('[data-image-women]');
    const menImage = document.querySelector('[data-image-men]');
    const womenImageDesktop = document.querySelectorAll('[data-image-desktop-gender-women]');
    const menImageDesktop = document.querySelectorAll('[data-image-desktop-gender-men]');

    if (window.location.pathname === '/') {
      localStorage.setItem('gender_menu', 'women');
    } else if (window.location.pathname === '/pages/men') {
      localStorage.setItem('gender_menu', 'men')
    }

    function updateMenu() {
        const genderMenu = localStorage.getItem('gender_menu') || 'women';

        const isDesktop = window.innerWidth > 1200;

        const menus = [
        womenMenuDesktop, menMenuDesktop,
        womenMenuTablet, menMenuTablet,
        womenMenuMobile, menMenuMobile
        ];
        menus.forEach(menu => menu?.classList.remove('active'));

        let activeMenu;

        if (genderMenu === 'women') {
          if (isDesktop) activeMenu = womenMenuDesktop;
          else activeMenu = womenMenuMobile;
          menTabEls.forEach(el => {
            el.classList.remove('active');
          })
          womenTabEls.forEach(el => {
            el.classList.add('active');
          })

          menImage?.classList.remove('active');
          womenImage?.classList.add('active');

          menImageDesktop?.forEach(image => image.classList.remove('active'));
          womenImageDesktop?.forEach(image => image.classList.add('active'));
        } else {
          if (isDesktop) activeMenu = menMenuDesktop;
          else activeMenu = menMenuMobile;
           womenTabEls.forEach(el => {
            el.classList.remove('active');
          }) 

          menTabEls.forEach(el => {
            el.classList.add('active');
          })  

          womenImage?.classList.remove('active');
          menImage?.classList.add('active');

          womenImageDesktop?.forEach(image => image.classList.remove('active'));
          menImageDesktop?.forEach(image => image.classList.add('active'));
        }

        activeMenu?.classList.add('active');
    }

    updateMenu();

    genderNavButtons.forEach(button => {
      const link = button.querySelector('a');
      if (!link) return;

      button.addEventListener('click', function(event) {
        event.preventDefault();
        const gender = event.currentTarget.dataset.genderNav;

        localStorage.setItem('gender_menu', gender);

        if (gender == 'women' ) {
          window.location.href = '/';
        } else if (gender == 'men') {
          window.location.href = '/pages/men';
        }
      });
    });


    const logos = document.querySelectorAll('[data-logo-link]');
    logos.forEach(logo => {
      logo.addEventListener('click', function(event) {
        event.preventDefault();
        const gender = localStorage.getItem('gender_menu') || 'women';

        if (gender === 'men') {
          window.location.href = '/pages/men';
        } else {
          window.location.href = '/';
        }
      });
    });

    window.addEventListener('resize', updateMenu);
  });